/** Default hardware posture thresholds (must match backend defaults). */

export const DEFAULT_POSTURE_THRESHOLDS = {
  workstation_ram_red_below_mb: 4096,
  workstation_ram_amber_below_mb: 7800,
  server_ram_red_below_mb: 7800,
  server_ram_amber_below_mb: 15872,
  disk_low_pct: 10,
  disk_low_gb: 5,
  disk_critical_pct: 5,
  disk_critical_gb: 2,
  small_drive_below_gb: 128,
  cpu_cores_red_below: 2,
  cpu_cores_amber_below: 4,
  cpu_speed_amber_below_mhz: 2000,
  bios_age_amber_years: 4,
  toolkit_memory_warn_used_pct: 80,
  toolkit_memory_fail_used_pct: 90,
}

let cached = null
let inflight = null

export function mergePostureThresholds(raw) {
  return { ...DEFAULT_POSTURE_THRESHOLDS, ...(raw || {}) }
}

export function clearPostureThresholdsCache() {
  cached = null
  inflight = null
}

/** Cached GET for device pages; clears after Admin save. */
export async function loadPostureThresholds(fetcher) {
  if (cached) return cached
  if (!inflight) {
    inflight = Promise.resolve()
      .then(() => fetcher())
      .then((data) => {
        cached = mergePostureThresholds(data)
        return cached
      })
      .catch(() => {
        cached = { ...DEFAULT_POSTURE_THRESHOLDS }
        return cached
      })
      .finally(() => {
        inflight = null
      })
  }
  return inflight
}
